





































import {Component, Vue, Mixins} from "vue-property-decorator";
import {TrackedLinkService, TrackedLink, TrackedLinkRequest} from "@/services/trackedLink.service";
import ClipboardMixin from "./../mixins/ClipboardMixin";
import { HashMap } from "../services/base.service";
import FormGroup from "@/components/ui/forms/FormGroup.vue";
import CardCollapsible from "@/components/ui/CardCollapsible.vue";

@Component({
    components: {
        FormGroup,
        CardCollapsible,
    }
})
export default class TrackedLinkManager extends Mixins(ClipboardMixin) {
    private service!: TrackedLinkService;
    private list: TrackedLink[] = [];

    private request!: TrackedLinkRequest;

    private errors: HashMap<string> = {};

    private async getList() {
        const res = await this.service.get();
        if (res.success) this.list = res.result;
    }

    private async remove(item: TrackedLink) {
        await this.service.delete(item.id);
        this.getList();
    }

    private async submit() {
        const res = await this.service.post(this.request);
        if (res.success) {
            this.clear();
            this.getList();
        } else {
            this.errors = res.error;
        }
    }

    private copy(item: TrackedLink) {
        this.copyToClipboard(item.link + "?src=" + item.encodedSource);
    }

    private clear() {
        this.request = {
            link: "",
            source: "",
        }
    }

    private created() {
        this.service = new TrackedLinkService();
        this.clear();
        this.getList();
    }
}
